import React from 'react';
import IngPortoApp from './IngPortoApp';
import { BrowserRouter as Router } from 'react-router-dom';

const App = () => {
  return ( 
    <Router>
     <IngPortoApp/>
    </Router>
   );
}
 
export default App;